import { FormControlLabel, Radio } from "@material-ui/core";
import React from "react";
// import { Col, Container, Row } from "react-bootstrap";
import { Modal } from "react-responsive-modal";
import { PopupInsideButton } from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import { DropDownButton } from "../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

export const FilterTableManagement = ({
  status,
  onOpenModal,
  open,
  onCloseModal,
  seatingStatus,
  onClickAll,
  onClickWalkin,
  onClickSeated,
  onClickNonSeated,
  showText,
  showTextTwo,
  displayText,
  onStatusClick,
  eventsMoreOptions,
  displayDataMap,
}) => {
  return (
    <React.Fragment>
      <button
        type="button"
        className="enIconBtn mr-3 btn btn-link"
        onClick={onOpenModal}
      >
        <i
          className="fa fa-filter"
          style={{ color: "#000000" }}
          aria-hidden="true"
        ></i>
      </button>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="reusable-popup-header-newstyle">
          <h4 className="c-black font_24_b">{displayText}</h4>
        </div>
        <div className="d-flex">
          <FormControlLabel
            value="0"
            control={<Radio color="primary" name="type" />}
            label="Table Status"
            name="type"
          />
          <FormControlLabel
            value="1"
            control={<Radio color="primary" name="type" />}
            label="Table Size"
            name="type"
          />
        </div>
        <div className="">
          <h4 className="font_22_m mt-5 mb-5">
            Select one relevant option from below
          </h4>
          {(displayText === "Select Section" ||
            displayText === "Seating Prefarence") && (
            <>
              <div className="row justify-content-start">
                {displayDataMap.map((data, index) => {
                  return (
                    <div className="col-4" key={index}>
                      <PopupInsideButton
                        buttonClass={
                          seatingStatus === "1"
                            ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                            : "status-selected-button-box font_20_m"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        // onClick={onClickAll}
                      />
                    </div>
                  );
                })}
              </div>
            </>
          )}
          {displayText === "Select Floor" && (
            <>
              <div className="row justify-content-start">
                <div className="col-4">
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "1"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                        : "status-selected-button-box font_20_m"
                    }
                    buttonText="Floor 1"
                    buttonType="button"
                    // onClick={onClickAll}
                  />
                </div>
                <div className="col-4">
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "2"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                        : "status-selected-button-box font_20_m"
                    }
                    buttonText="Floor 2"
                    buttonType="button"
                    // onClick={onClickAll}
                  />
                </div>
                <div className="col-4">
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "3"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                        : "status-selected-button-box font_20_m"
                    }
                    buttonText="Floor 3"
                    buttonType="button"
                    // onClick={onClickAll}
                  />
                </div>
                <div className="col-4">
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "4"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                        : "status-selected-button-box font_20_m"
                    }
                    buttonText="Floor 4"
                    buttonType="button"
                    // onClick={onClickAll}
                  />
                </div>
                <div className="col-4">
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "5"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                        : "status-selected-button-box font_20_m"
                    }
                    buttonText="Floor 5"
                    buttonType="button"
                    // onClick={onClickAll}
                  />
                </div>
              </div>
            </>
          )}
          <div className="mt-5 d-flex">
            <ReusableOnboardingButton
              buttonTitle="Cancel Button"
              buttonClass={
                "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              }
              buttonText="Cancel"
              onClick={onCloseModal}
              buttonType="button"
            />
            <ReusableOnboardingButton
              buttonTitle="Confirm Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              buttonText="Confirm"
              // onClick={onStatusClick}
              buttonType="button"
            />
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
